import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

let root: string;
switch (process.env.NODE_ENV) {
	case 'production':
		root = 'https://api.gouspack.com';
		break;
  case 'staging':
		root = 'https://api.gouspack.com';
		break;
	case 'development':
		root = 'https://api.gouspack.com';
		break;
	default:
		throw new Error(`Unrecognized NODE_ENV value, '${process.env.NODE_ENV}'`);
}

const httpOptions: VueResource.Http = (Vue as unknown as { http: VueResource.Http })['http'];
httpOptions.options.root = root;

